export const checkboxData = {
    photographyServiceOfferOption: [
        { value: 'Candid Photography', label: 'Candid Photography' },
        { value: 'Traditional Phorography', label: 'Traditional Phorography' },
        { value: 'Cinematic Video', label: 'Cinematic Video' },
        { value: 'Traditional Video', label: 'Traditional Video' },
        { value: 'Photo Album', label: 'Photo Album' },
        { value: 'Pre-wedding Shoot', label: 'Pre-wedding Shoot' },
        { value: 'Drone', label: 'Drone' },
        { value: 'Photobooth', label: 'Photobooth' }
    ],
    decorPolicyOption: [
        { value: 'Fixed Decoration Available', label: 'Fixed Decoration Available' },
        { value: 'Decorators on Panel', label: 'Decorators on Panel' },
        { value: 'Outside Decorator is Allowed', label: 'Outside Decorator is Allowed' },
        { value: 'Outside Decorator is not Allowed', label: 'Outside Decorator is not Allowed' },
    ],
    alcoholPolicyOption: [
        { value: 'In House Alcohol Available', label: 'In House Alcohol Available'},
        { value: 'Outside Alcohol Allowed', label: 'Outside Alcohol Allowed'},
        { value: 'Outside Alcohol not Allowed', label: 'Outside Alcohol not Allowed'},
        { value: 'Alcohol not Allowed', label: 'Alcohol not Allowed'}
    ],
    destinationVenue: [
        { value: 'Hill Places', label: 'Hill Places' },
        { value: 'Beach Places', label: 'Beach Places' },
        { value: 'Historical Places', label: 'Historical Places' },
        { value: 'International Wedding', label: 'International Wedding' },
        { value: 'Budget Destination Wedding', label: 'Budget Destination Wedding' },
    ],
    djPolicyOption: [
        { value: 'In House DJ', label: 'In House DJ' },
        { value: 'DJ on Panel', label: 'DJ on Panel' },
        { value: 'Outside DJ is allowed', label: 'Outside DJ is allowed' },
        { value: 'DJ not allowed', label: 'DJ not allowed' },
    ],
    caterPolicyOptions: [
        { value: 'In House Catering', label: 'In House Catering' },
        { value: 'Outside Catering Allowed', label: 'Outside Catering Allowed' },
        { value: 'Outside Catering not Allowed', label: 'Outside Catering not Allowed' },
        { value: 'In Panel Catering Only', label: 'In Panel Catering Only' }
    ],
    paymentMethod: [
        { value: 'Cash', label: 'Cash' },
        { value: 'Creadit Card', label: 'Creadit Card' },
        { value: 'Debit Card', label: 'Debit Card' },
        { value: 'Net Banking', label: 'Net Banking' },
    ],
    serviceOfferedPlanner: [
        { value: 'Maternity Shoot', label: 'Maternity Shoot' },
        { value: 'Fashion Shoot', label: 'Fashion Shoot' },
        { value: 'Birthday Shoot', label: 'Birthday Shoot' },
        { value: 'Wedding Event Shoot', label: 'Wedding Event Shoot' },
        { value: 'Social Event Shoot', label: 'Social Event Shoot' },
        { value: 'Corporate Shoot', label: 'Corporate Shoot' },
        { value: 'Pre Wedding Shoot', label: 'Pre Wedding Shoot' },
        { value: 'Others', label: 'Others' },
    ],
    areaOfWorking: [
        { value: 'In City Only', label: 'In City Only' },
        { value: 'Out Of City', label: 'Out Of City' },
        { value: 'Depends on Event', label: 'Depends on Event' },
        { value: 'Any City', label: 'Any City' },
    ],
    travelCost: [
        { value: 'inclusive', label: 'exclusive' },
    ],
    travelPreference: [
        { value: 'In Studio', label: 'In Studio' },
        { value: 'Flexible', label: 'Flexible' },
        { value: 'Travel to Venue', label: 'Travel to Venue' },
    ],
    cardSpecialty: [
        { value: 'Funky & off-beat Invitations', label: 'Funky & off-beat Invitations' },
        { value: 'Modern Invites', label: 'Modern Invites' },
        { value: 'Tradinational Invitations', label: 'Tradinational Invitations' },
    ],
    servicesOffered: [
        { value: 'DJ Music', label: 'DJ Music' },
        { value: 'Venue Booking', label: 'Venue Booking' },
        { value: 'Decor', label: 'Decor' },
        { value: 'Invitations', label: 'Invitations' },
        { value: 'Photography', label: 'Photography' },
        { value: 'Catering', label: 'Catering' },
        { value: 'Other Services', label: 'Other Services' },

    ],
    planningTypeWed: [
        { value: 'Full Wedding Planning', label: 'Full Wedding Planning' },
        { value: 'Booking All Services', label: 'Booking All Services' },
        { value: 'Co-ordination', label: 'Co-ordination' },
        { value: 'Partial Planning', label: 'Partial Planning' },
        { value: 'Consultation', label: 'Consultation' },
    ],
    planningTypeCop: [
        { value: 'Conference & Seminars', label: 'Conference & Seminars' },
        { value: 'Product Launches', label: 'Product Launches' },
        { value: 'Trade Shows & Exhibitions', label: 'Trade Shows & Exhibitions' },
        { value: 'Sales Meetings', label: 'Sales Meetings' },
        { value: 'Award Ceremonies', label: 'Award Ceremonies' },
        { value: 'Corporate Social Responsibility', label: 'Corporate Social Responsibility' },
        { value: 'Milestone Celebrations', label: 'Milestone Celebrations' },
        { value: 'Others', label: 'Others' },
    ],
    planningTypeGov: [
        { value: 'Inaugurations', label: 'Inaugurations' },
        { value: 'State of The Union Addresses', label: 'State of The Union Addresses' },
        { value: 'Summits & Conferences', label: 'Summits & Conferences' },
        { value: 'Legislative Sessions', label: 'Legislative Sessions' },
        { value: 'Cabinet Meetings', label: 'Cabinet Meetings' },
        { value: 'Press Conferences', label: 'Press Conferences' },
        { value: 'Road Shows', label: 'Road Shows' },
        { value: 'National Celebrations', label: 'National Celebrations' },
        { value: 'Others', label: 'Others' },
    ],
    workSinceOption: [
       { value: 'New Business', label: 'New Business' },
        { value: '1+ year', label: '1+ year' },
        { value: '2+ year', label: '2+ year' },
        { value: '5+ year', label: '5+ year' },
        { value: '10+ year', label: '10+ year' }
    ],
    typeOfSafa:[
        { value: 'Khirki Dar Pagdi', label: 'Khirki Dar Pagdi' },
        { value: 'Paag', label: 'Paag' },
        { value: 'Pheta', label: 'Pheta' },
        { value: 'Peta', label: 'Peta' },
        { value: 'Rajasthani Pagdi', label: 'Rajasthani Pagdi' },
        { value: 'Peshawari Pagdi', label: 'Peshawari Pagdi' },
        { value: 'Other', label: 'Other' },
    ],
    mehandiDesignType: [
        { value: 'Arbic', label: 'arbic' },
        { value: 'Indo-arbic', label: 'Indo-arbic' },
        { value: 'Indian', label: 'Indian' },
        { value: 'Western', label: 'Western' }
    ],
    spaceOption: [
        { value: 'Indoor', label: 'Indoor' },
        { value: 'Outdoor', label: 'Outdoor' },
        { value: 'Pool Side', label: 'Pool Side' },
        { value: 'Terrace', label: 'Terrace' },
    ],
    smallPartyOption: [
        { value: 'Yes! Less than 50 pax Allowed', label: 'Yes! Less than 50 pax Allowed' },
        { value: 'Yes! Less than 100 pax Allowed', label: 'Yes! Less than 100 pax Allowed' },
        { value: 'Yes! Less than 200 pax Allowed', label: 'Yes! Less than 200 pax Allowed' },
        { value: 'Not Allowed', label: 'Not Allowed' },
    ],
    parkingOption: [
        { value: 'Sufficient Parking', label: 'Sufficient Parking' },
        { value: 'Limited Parking', label: 'Limited Parking' },
        { value: 'Large Parking Space', label: 'Large Parking Space' },
    ],
    deliveryDate: [
        { value: 'Within a Week', label: 'Within a Week' },
        { value: 'Within Two Weeks', label: 'Within Two Weeks' },
        { value: 'Within a Month', label: 'Within a Month' },
        { value: 'Within Two Months', label: 'Within Two Months' },
    ],
    serviceTypeDecor: [
        { value: 'Floar Decor', label: 'Floar Decor' },
    ],
    serviceTypeBirthdayDecor: [
        { value: 'Flower Decor', label: 'Flower Decor' },
        { value: 'Balloon Decor', label: 'Balloon Decor' },
        { value: 'Theme Decor', label: 'Theme Decor' },
        { value: 'All Types of Decor', label: 'All Types of Decor' },
    ],
    serviceTypeEntryTheme:[
        { value: 'Bride Groom Entry', label: 'Bride Groom Entry' },
        { value: 'Sky Shorts', label: 'Sky Shorts' },
        { value: 'Mataka Entry', label: 'Mataka Entry' },
        { value: 'Cold Hand Pyro Entry', label: 'Cold Hand Pyro Entry' },
        { value: 'CO2 Jet Machine', label: 'CO2 Jet Machine' },
        { value: 'Sparkle Machine', label: 'Sparkle Machine' },
        { value: 'Dance Troop', label: 'Dance Troop' },
        { value: 'Ganga Aarti Theme', label: 'Ganga Aarti Theme' },
        { value: 'Bubble machine', label: 'Bubble machine' },
        { value: 'Girl & Boy Artist', label: 'Girl & Boy Artist'}
    ],
    experienceZoneDecor: [
        { value: 'Local Weddings', label: 'Local Weddings' },
    ],
    onThePannalOfDecor: [
        { value: 'Sapna Clarks Inn', label: 'Sapna Clarks Inn' },
        { value: 'Levana', label: 'Levana' },
        { value: 'Linege', label: 'Linege' },
        { value: 'Picadily', label: 'Picadily' },
        { value: 'Lebua', label: 'Lebua' },
        { value: 'Hyatt', label: 'Hyatt' },
        { value: 'Ramda', label: 'Ramda' },
        { value: 'Savy Grand', label: 'Savy Grand' },
        { value: 'Other', label: 'Other' },
    ],
    planningTypeDecor: [
        { value: 'Full Decoration', label: 'Full Decoration' },
        { value: 'Partial Decoration', label: 'Partial Decoration' }
    ],
    paymentPolicyDecor: [
        { value: '70% At The Time of Booking', label: '70% At the Time of Booking' },
        { value: '20% On Event Date', label: '20% On Event Date' },
    ],

    favouriteMusic: [
        { value: 'Bollywood', label: 'Bollywood' },
        { value: 'Hollywood', label: 'Hollywood' },
        { value: 'Punjabi', label: 'Punjabi' },
        { value: 'Hip-Hop', label: 'Hip-Hop' },
        { value: 'House/EDM', label: 'House/EDM' },
        { value: 'Rock', label: 'Rock' },
        { value: 'Others', label: 'Others' },
    ],
    languageOption: [
        { value: 'Sanskrit', label: 'Sanskrit' },
        { value: 'Hindi', label: 'Hindi' },
        { value: 'English', label: 'English' },
        { value: 'Bengali', label: 'Bengali' },
        { value: 'Marathi', label: 'Marathi' },
        { value: 'Telugu', label: 'Telugu' },
        { value: 'Tamil', label: 'Tamil' },
        { value: 'Gujarati', label: 'Gujarati' },
        { value: 'Urdu', label: 'Urdu' },
        { value: 'Kannada', label: 'Kannada' },
        { value: 'Punjabi', label: 'Punjabi' }
    ],
    serviceOfferedPandit: [
        { value: 'Wedding Ceremony', label: 'Wedding Ceremony' },
        { value: 'Hawan', label: 'Hawan' },
        { value: 'Gauri Pooja', label: 'Gauri Pooja' },
        { value: 'Griha Pravesh', label: 'Griha Pravesh' },
        { value: 'Lakshmi Pooja', label: 'Lakshmi Pooja' },
        { value: 'Sundarkand/Mata Ki Chowki', label: 'Sundarkand/Mata Ki Chowki' },
        { value: 'Mangal Dosh', label: 'Mangal Dosh' },
        { value: 'Others', label: 'Others' }

    ],
    samagriOption: [
        { value: 'Not Included', label: 'Not Included' },
        { value: 'Included', label: ' Included' },
    ],
    eventTypeAnchor: [
        { value: 'Corporate', label: 'Corporate' },
        { value: 'Pre-Wedding', label: 'Pre-Wedding' },
        { value: 'Wedding', label: 'Wedding' },
        { value: 'Sagan', label: 'Sagan' },
        { value: 'Private Party', label: 'Private party' },
        { value: 'Cocktail Party', label: 'Cocktail Party' },
        { value: 'Other Function', label: 'Other Function' },
    ],
    typeOfArtist: [
        { value: 'Bollywood Music Band', label: 'Bollywood Music Band' },
        { value: 'Sufi Band', label: 'Sufi Band' },
        { value: 'Westurn Music Band', label: 'Westurn Music Band' },
        { value: 'Lagan Geet Artist', label: 'Lagan Geet Artist' },
        { value: 'Shehnai Artist', label: 'Shehnai Artist' },
        { value: 'Folk Music', label: 'Folk Music' },
        { value: 'Jagran', label: 'Jagran' },
        { value: 'Others', label: 'Others' },
    ],
    previousWedding: [
        { value: 'Lucknow', label: 'Lucknow' },
        { value: 'Jim-Corbett', label: 'Jim-Corbett' },
        { value: 'Delhi', label: 'Delhi' },
        { value: 'Jaipur', label: 'Jaipur' },
    ],
    servicesOfferedPlanner: [
        { value: 'DJ Music', label: 'DJ Music' },
        { value: 'Venue Booking Decor', label: 'Venue Booking Decor' },
        { value: 'Invitations', label: 'Invitations' },
        { value: 'Photography', label: 'Photography' },
        { value: 'Events', label: 'Events' },
        { value: 'Other Services', label: 'Other Services' },
    ],
    storeTypeGroom: [
        { value: 'Rental Store', label: 'Rental Store' },
        { value: 'Couture Brand', label: 'Couture Brand' },
    ],
    serviceOfferedGroom: [
        { value: 'Designer Sherwani', label: 'Designer Sherwani' },
        { value: 'Kurta Payjama', label: 'Kurta Payjama' },
        { value: 'ReadyMade Kurtas', label: 'ReadyMade Kurtas' },
        { value: 'Formal', label: 'Formal' },
        { value: 'Casual Coats', label: 'Casual Coats' },
        { value: 'Designer Suit', label: 'Designer Suit' },
        { value: 'Indo-Western', label: 'Indo-Western' },
        { value: 'ReadyMade Shirts', label: 'ReadyMade Shirts' },
        { value: 'Trousers', label: 'Trousers' },
        { value: 'Jeans', label: 'Jeans' },
        { value: 'T-shirt', label: 'T-shirt' }
    ],
    PopularFlavourCake: [
        { value: 'Beligan Chocoklate', label: 'Beligan Chocoklate' },
        { value: 'Couture Brand', label: 'Couture Brand' },
    ],
    eventTypeBand: [
        { value: 'Pre-Wedding', label: 'Pre-Wedding ' },
        { value: 'Wedding', label: 'Wedding' },
        { value: 'Sagan', label: 'Sagan' },
        { value: 'Birthday Party', label: 'Birthday Party' },
        { value: 'Anniversary', label: 'Anniversary' },
        { value: 'Corporate Events', label: 'Corporate Events' },
        { value: 'Others', label: 'Others' },
    ],
    serviceOfferedOnRent: [
        { value: 'Bridal Lehenga', label: 'Bridal Lehenga' },
        { value: 'Saree', label: 'Saree' },
        { value: 'Gown', label: 'Gown' },
        { value: 'Groom Wear', label: 'Groom Wear' },
        { value: 'Kids Wear', label: 'Kids Wear' },
        { value: 'Bridal Jwellery', label: 'Bridal Jwellery' },
        { value: 'Brunch Party Dresses', label: 'Brunch Party Dresses' },
        { value: 'Wedding Dresses ', label: 'Wedding Dresses ' },
        { value: 'Pre wedding shoots outfits ', label: 'Pre wedding shoots outfits ' },
        { value: 'Maternity shoots outfit  ', label: 'Maternity shoots outfit  ' },
        { value: 'Ethnic wear', label: 'Ethnic wear' },
        { value: 'Indo-western', label: 'Indo-western' },
        { value: 'Sherwani', label: 'Sherwani' },
        { value: "Men's Indo-westerns men’s suits", label: "Men's Indo-westerns men’s suits" },
        { value: 'kurtas', label: 'kurtas' },
        { value: 'Saafas', label: 'Saafas' },
        { value: 'Rental jewellery for grooms', label: 'Rental jewellery for grooms' },
        { value: 'Western wear', label: 'Western wear' },
    ],
    birthadayDecorationItems: [
        { value: 'Balloones Accessories', label: 'Balloones Accessories' },
        { value: 'Backdrop Decoration', label: 'Backdrop Decoration' },
        { value: 'Birthday Props', label: 'Birthday Props' },
        { value: 'Birthday Banners', label: 'Birthday Banners' },
    ],
    serviceOfferedband: [
        { value: 'Traditional Band', label: 'Traditional Band' },
        { value: 'DJ Band', label: 'DJ Band' },
        { value: 'Sehani', label: 'Sehani' },
        { value: 'Fireworks', label: 'Fireworks' },
        { value: 'Dhol', label: 'Dhol' },
        { value: 'Baggi', label: 'Baggi' },
        { value: 'Palki', label: 'Palki' },
        { value: 'Doli', label: 'Doli' },
        { value: 'Ghodi', label: 'Ghodi' },
        { value: 'Juggley Artist', label: 'Juggley Artist' },
        { value: 'Others', label: 'Others' }
    ],
    setatplace: [
        { value: 'Taj', label: 'Taj' },
        { value: 'Ravada', label: 'Ravda' },
    ],
    busVehicle: [

        { value: 'Mini Bus', label: 'Mini Bus' },
        { value: 'Delux Bus', label: 'Delux Bus' },
        { value: 'Non Delux Bus', label: 'Non Delux Bus' },
        { value: 'Traveller Bus', label: 'Traveller Bus' },
        { value: 'Volvo Luxery Bus', label: 'Volvo Luxery Bus' },
    ],
    busType: [
        { value: 'A.C.', label: 'A.C.' },
        { value: 'Non A.C.', label: 'Non A.C.' },
        { value: 'A.C.With Sleeper', label: 'A.C.With Sleeper' },
    ],
    popularFlavourCake: [
        { value: 'French Vanilla', label: 'French Vanilla' },
        { value: 'Butter Scotch ', label: 'Butter Scotch' },
        { value: 'Coconut', label: 'Coconut' },
        { value: 'Chocalate', label: 'Chocalate' },
        { value: 'Orange', label: 'Orange' },
        { value: 'Brandy', label: 'Brandy' },
        { value: 'Lemon Fruit', label: 'Lemon Fruit' },
        { value: 'Chocolate Fudge', label: 'Chocolate Fudge' },
        { value: 'Coffee', label: 'Pineapple' },
    ],
    specialtyCake: [

        { value: 'Cake in a for specialist', label: 'Cake in a for specialist' },
        { value: 'Wedding Cakes', label: 'Wedding Cakes' },
        { value: 'Specialist CupCake', label: 'Specialist CupCake' },
        { value: 'Chandelier Cakes', label: 'Chandelier Cakes' },
        { value: 'Ice-cream cake', label: 'Ice-cream cake' },
    ],
    cakesShape: [

        { value: 'Round', label: 'Round' },
        { value: 'Heart', label: 'Heart' },
        { value: 'Square', label: 'Square' },

    ],
    rentalVehicle: [
        { value: 'Wagon R', label: 'Wagon R' },
        { value: 'Swift Dzire ', label: 'Swift Dzire' },
        { value: 'Xcent', label: 'Xcent' },
        { value: 'Ertiga ', label: 'Ertiga' },
        { value: 'Scorpio', label: 'Scorpio' },
        { value: 'B.M.W', label: 'B.M.W' },
        { value: 'Toyota Innova', label: 'Toyota Innova' },
        { value: 'Sabara', label: 'Sabara' },
        { value: 'Toyota Crysta', label: 'Toyota Crysta' },
        { value: 'Bentley', label: 'Bentley' },
        { value: 'Mercedes Benz', label: 'Mercedes Benz' },
        { value: 'Porche', label: 'Porche' },
        { value: 'Jaguar', label: 'Jaguar' },
        { value: 'Rolls Royce', label: 'Rolls Royce' },
        { value: 'Land Rover', label: 'Land Rover' },
        { value: 'Audi', label: 'Audi' },
        { value: 'Mahindra Thar', label: 'Mahindra Thar' },
        { value: 'Mahindra XUV 700', label: 'Mahindra XUV 700' },
        { value: 'Kia', label: 'Kia' },
        { value: 'Maybach', label: 'Maybach' },
        { value: 'Vintage', label: 'Vintage' },
        { value: 'Other', label: 'Other' },
    ],

    carsRentalDuration: [

        { value: 'Hours', label: 'Hours' },
        { value: 'Day', label: 'Day' },
    ],
    carsPurpose: [

        { value: 'Wedding', label: 'Wedding' },
        { value: 'Destination', label: 'Destination' },
        { value: 'Wedding', label: 'Wedding' },
        { value: 'Business', label: 'Business' },
        { value: 'OutStation', label: 'OutStation' },
        { value: 'Trip', label: 'Trip' },
    ],
    driveType: [

        { value: 'Self Drive', label: 'Self Drive' },
        { value: 'With Drive', label: 'With Drive' },
    ],
    eventTypeMagician: [

        { value: 'Corporate', label: 'Corporate' },
        { value: 'Wedding', label: 'Wedding' },
        { value: 'Birthday Parties', label: 'Birthday Parties' },
        { value: 'Other Familly Functions', label: 'Other family functions' },
    ],
    requirementMagician: [
        { value: 'A Stage', label: 'A Stage' },
        { value: 'A Mic', label: 'A Mic' },
        { value: 'No Requirements', label: 'No Requirements' }
    ],
    durationMagicians: [
        { value: '1 hour', label: '1 hour' },
        { value: '2 hours', label: '2 hours' },
        { value: '3 hours', label: '3 hours' },
    ],
    travelPreferenceMagician: [
        { value: 'Travel same city', label: 'Travel same city' },
        { value: 'out of station', label: 'out of station' },
    ],
    serviceOfferedFlorish: [

        { value: 'Interior designer', label: 'Interior designer' },
        { value: 'Decorators', label: 'Decorators' },
    ],
    planningTypeFlorish: [
        { value: 'Consultant', label: 'Consultant' },
        { value: 'Coordination', label: 'Coordination' },
        { value: 'Full Plannig', label: 'Full Planning' },
        { value: 'Partial Planning', label: 'Partial Planning' },
    ],
    travelPreferenceFlorish: [
        { value: 'Same City', label: 'Same City' },
        { value: 'Out of Station', label: 'Out of Station' },
    ],
    favourGiftsOption: [
        { value: 'Wedding Gifts', label: 'Wedding Gifts' },
        { value: 'Birthday Gifts', label: 'Birthday Gifts' },
        { value: 'Gift Basket', label: 'Gift Basket' },
        { value: 'Others', label: 'Others' },
    ],
    productUsedOption: [
        { value: 'MAC Cosmetics', label: 'MAC Cosmetics' },
        { value: 'Loreal', label: 'Loreal' },
        { value: 'Too faced', label: 'Too faced' },
        { value: 'NARS', label: 'NARS' },
        { value: 'Laura Mercier', label: 'Laura Mercier' },
        { value: 'MAC', label: 'MAC' },
        { value: 'Tarte', label: 'Tarte' },
        { value: 'Kat Von D', label: 'Kat Von D' },
        { value: 'Estee Lauder', label: 'Estee Lauder' },
        { value: 'Maybelline', label: 'Maybelline' },
        { value: 'Urban Decay', label: 'Urban Decay' },
        { value: 'NARS Cosmetic', label: 'NARS Cosmetic' },
        { value: 'Clinique', label: 'Clinique' },
        { value: 'Makeup Revolution', label: 'Makeup Revolution' },
        { value: 'Loreal Paris', label: 'Loreal Paris' },
        { value: 'Revlon', label: 'Revlon' },
        { value: 'Shiseido', label: 'Shiseido' },
        { value: 'Bobbi Brown', label: 'Bobbi Brown' },
        { value: 'Chambor', label: 'Chambor' },
        { value: 'NYX professional Makeup ', label: 'NYX professional Makeup' },
        { value: 'Anastasia Beverly Hills ', label: 'Anastasia Beverly Hills' },
        { value: 'Smashbox ', label: 'Smashbox' },
        { value: 'Estee Lauder', label: 'Estee Lauder' },
        { value: 'Elizabeth Arden ', label: 'Elizabeth Arden' },
        { value: 'Sephora ', label: 'Sephora' },
        { value: 'Make Up For Ever', label: 'Make Up For Ever' },
        { value: 'Avon ', label: 'Avon' },
        { value: 'Lakme Cosmetics', label: 'Lakme Cosmetics' },
        { value: 'Clarins', label: 'Clarins' },
        { value: 'Stila ', label: 'Stila' },
        { value: 'CoverGirl', label: 'CoverGirl' },
        { value: 'Huda Beauty', label: 'Huda Beauty' },
        { value: 'Charmacy Milano', label: 'Charmacy Milano' },
        { value: 'Krylon', label: 'Krylon' },
        { value: 'Swiss Beauty', label: 'Swiss Beauty' },
        { value: 'Europe Girl', label: 'Europe Girl' },
        { value: 'Charlotte Tilbury', label: 'Charlotte Tilbury' },
        { value: 'Chanel', label: 'Chanel' },
        { value: 'Dior', label: 'Dior' },
        { value: 'Gucci', label: 'Gucci' },
        { value: 'Armani', label: 'Armani' },
        { value: 'Others', label: 'Others' },
    ],
    durationType: [
        { value: 'hours', label: 'hours' },
        { value: '1 Day', label: '1 Day' },
        { value: '2 Day', label: '2 Day' },
        { value: '3 Day', label: '3 Day' },
        { value: '5 Day', label: '5 Day' },
    ],
    travellingType: [
        { value: 'Bus', label: 'Bus' },
        { value: 'Cars', label: 'Cars' },
        { value: 'Trains', label: 'Trains' },
        { value: 'Flights', label: 'Flights' },
        { value: 'Without Flights', label: 'Without Flights' },
    ],
    tourProvided: [
        { value: 'Manali', label: 'Manali' },
        { value: 'Srinagar', label: 'Srinagar' },
        { value: 'Gangtok', label: 'Gangtok' },
        { value: 'Darjelling', label: 'Darjelling' },
        { value: 'Jaipur', label: 'Jaipur' },
        { value: 'Nepal', label: 'Nepal' },
        { value: 'Other', label: 'Other' },
    ],
    servicedOfferedBridal: [

        { value: 'Bridal Lehanga(heavy and Light)', label: 'Bridal Lehanga(heavy and Light)' },
        { value: 'Party Wear Saree', label: 'Light Lehangas' },
        { value: 'Bridal Gown', label: 'Bridal Gown' },
        { value: 'Heavy and Light Weighted Salwar & Kameez', label: 'Heavy and Light Weighted Salwar & Kameez' },
        { value: 'Trousseau', label: 'Trousseau' },
    ],
    storeTypebridal: [
        { value: 'In Store Shopping ', label: 'In Store Shopping ' },
        { value: 'Online Shopping', label: 'Online Shopping' },
    ],
    customizationbridal: [
        { value: 'Customization is Available ', label: 'Customization is Available' },
        { value: 'Customization is not Available', label: 'Customization is not Available' },
    ],
    starRating: [
        { value: ' 1 star', label: '1 star' },
        { value: ' 2 star', label: '2 star' },
        { value: ' 3 star', label: '3 star' },
        { value: ' 4 star', label: '4 star' },
        { value: ' 5 star', label: '5 star' },
    ],
    travelPreferenceChoreographer: [
        { value: 'Travel same city', label: 'Travel same city' },
        { value: 'out of station', label: 'out of station' },
    ],
    choreographerStyle: [
        { value: 'Bollywood', label: 'Bollywood' },
        { value: 'Old Hindi Songs', label: 'Old Hindi Songs' },
        { value: 'Contemporary', label: 'Contemporary' },
        { value: 'Punjabi', label: 'Punjabi' },
        { value: 'Ball Dance', label: 'Ball Dance' },
        { value: 'Classical Dance', label: 'Classical Dance' },
        { value: 'Hip-Hop', label: 'Hip-Hop' },
        { value: 'Western', label: 'Western' },
        { value: 'Others', label: 'Others' },
    ],
    artistType:[
        { value: 'Singers', label: 'Singers' },
        { value: 'Dancers', label: 'Dancers' },
        { value: 'Comedians', label: 'Comedians' },
        { value: 'Guest Appearance', label: 'Guest Appearance' },
        { value: 'Others', label: 'Others' },
    ],
    performancePreference: [
        { value: 'Studio', label: 'Studio' },
        { value: 'Client Site', label: 'Client Site' },
        { value: 'Online Sessions', label: 'Online Sessions' },
        { value: 'Recorded Sessions ', label: 'Recorded Sessions' },
        { value: 'Flexible ', label: 'Flexible' },
    ],
    eventServiceHelecopter: [
        { value: 'Helecopter for Marriage ', label: ' Helecopter for Marriage' },
        { value: 'Helecopter for Film Shooting', label: 'Helecopter for Film Shotting' },
        { value: 'Helecopter for Flower Showing ', label: ' Helecopter for Flower Showing' },
        { value: 'Helecopter for joy Booking ', label: ' Helecopter for joy Booking' },
        { value: 'Helecopter for Char Dham Tour', label: 'Helecopter for Char Dham Tour' },
        { value: 'Helecopter for Air Ambulance Services ', label: ' Helecopter for Air Ambulance Services' },
        { value: 'Helecopter for Election Campagin', label: 'Helecopter for Election Campagin' },
    ],
    helecopterName: [
        { value: 'Robinson R44 ', label: 'Robinson R44 ' },
        { value: 'Bell 206', label: 'Bell 206' },
        { value: 'As 350B3 ', label: 'As 350B3' },
        { value: ' Bell 407', label: 'Bell 407' },
        { value: 'Robinson R66', label: 'Robinson R66' },

    ],
    vitageCarsServices: [
        { value: 'Vintage Cars For Marriage ', label: 'Vintage Cars For Marriage' },
        { value: 'Vintage Cars For CityTour ', label: 'Vintage Cars For CityTour' },
        { value: 'Vintage Cars For Picture Shooting ', label: 'Vintage Cars For Picture Shooting' },

    ],
    vintageCarsName: [
        { value: 'Austin 7,8 ', label: 'Austin 7,8' },
        { value: 'Fiat 1100 Select,1961', label: 'Fiat 1100 Select,1961' },
        { value: 'Hill Man Minx,1946 ', label: 'Hill Man Minx,1946' },
        { value: 'Mersedes-Benz E-class 2000 ', label: 'Mersedes-Benz E-class 2000' },
        { value: 'Morris Minor 1000', label: 'Morris Minor 1000' },
        { value: 'Morris 1953', label: 'Morris 1953' },
        { value: 'Hillman 1932', label: 'Hillman 1932' },
        { value: 'Dodge Hornet 1956', label: 'Dodge Hornet 1956' },
        { value: 'Others', label: 'Others' }
    ],
    jewelleryType: [
        { value: 'Gold', label: 'Gold' },
        { value: 'Silvar', label: 'Silvar' },
        { value: 'Diamond', label: 'Diamond' },
        { value: 'Artifical', label: 'Artifical' },
        { value: 'Western', label: 'Western' },
        { value: 'Polished stones', label: 'Polished stones' },
        { value: 'Persian Stone', label: 'Persian Stone' },
        { value: 'Celebrity', label: 'Celebrity' },
        { value: 'Traditional', label: 'Traditional' },
    ],
    categoriesServe: [
        { value: 'Men', label: 'Men' },
        { value: 'Women', label: 'Women' },
        { value: 'Kids', label: 'Kids' },
    ],
    storeType: [
        { value: 'In Store Shopping', label: 'In Store Shopping' },
        { value: 'Online Shopping', label: 'Online Shopping' },
    ],
}